module.exports = __webpack_public_path__ + "img/elephant_half.ef9f4b47.svg";